import { usePageViewTracking } from '../hooks/usePageViewTracking';

// Renders nothing — just runs the page_view logging hook. Must be mounted
// inside <BrowserRouter> (useLocation requires router context), so it can't
// live directly in App.tsx's own body.
const AnalyticsTracker = () => {
  usePageViewTracking();
  return null;
};

export default AnalyticsTracker;
